export default __webpack_public_path__ + "static/media/moi.3d086a98.webp";